export default __webpack_public_path__ + "static/banner-the-pros-and-cons-of-new-and-used-cars-ee44fed593bc8b514bdea3ed81333dfb.jpg";